const contracts = {
  firestorePath: '/contracts',
  firestoreRefType: 'collection',
  moduleName: 'contracts',
  statePropName: 'contracts',
  namespaced: true,
  serverChange: {
    convertTimestamps: {
      created_at: '%convertTimestamp%', // default
      updated_at: '%convertTimestamp%', // default
        status_to_finished: '%convertTimestamp%', // default
    },
  },

  state: {
    contracts: null,
    shiftTypes: [
      'dagdienst',
      '2 ploegen',
      '3 ploegen',
      '4 ploegen',
      '5 ploegen',
      'nachtdienst',
      'vroege dienst',
      'late dienst',
      'onregelmatige dienst'
    ],
    paymentFrequencies: [
      'wekelijks',
      '4 wekelijks'
    ],
  },
  getters: {
    getcontracts: (state) => {
      return _.toArray(state.contracts);
    },
    getContractsDatatable: (state,getters,rootState,rootGetters) => {
      return _.toArray(state.contracts).map(contract => {
          return {
          ...contract,

          }});
    },
    getCustomer: (state) => (id) => {
      return state.contracts[id] ? state.contracts[id] : null
    },
    getAvailablecontractsPerCandidate: (state, getters, rootState, rootGetters) => (id) => {
      let placements = rootGetters['placements/getPlacements'];
      let contracts = _.toArray(state.contracts);

      var filteredPlacements = _.filter(placements, {'endDate': '', 'candidateId': id});
      var removedcontracts = [];

      if (filteredPlacements.length === 0) {
        return contracts
      } else {
        for (var p = 0; p < filteredPlacements.length; p++) {
          removedcontracts = _.remove(contracts, {
            id: filteredPlacements[p].customerId
          });
        }
      }
      return _.difference(contracts, removedcontracts);
    },
    getShiftTypes: (state) => {
      return state.shiftTypes;
    },
    getPaymentFrequencies: (state) => {
      return state.paymentFrequencies;
    }
  },
  mutations: {},
  actions: {},
}

export default contracts